// extracted by mini-css-extract-plugin
module.exports = {"chartLegend":"AnalyticsChartLegend_chartLegend__2hWDG","centered":"AnalyticsChartLegend_centered__LXS6p","chartLegendMark":"AnalyticsChartLegend_chartLegendMark__3jnc3"};